module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content show-small "
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentTab === _vm.tabs.korean || _vm.currentTab === _vm.tabs.all) ? _c('div', {
    staticClass: "horizontal-scroll-container"
  }, [_c('div', {
    staticClass: "horizontal-scroll-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/kr-anatomy.svg",
      "alt": "Korean Letter-form Anatomy"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentTab === _vm.tabs.english || _vm.currentTab === _vm.tabs.all) ? _c('div', {
    staticClass: "horizontal-scroll-container"
  }, [_c('div', {
    staticClass: "horizontal-scroll-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/en-anatomy.svg",
      "alt": "English Letter-form Anatomy"
    }
  })])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dece651","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LetterFormAnatomyScroll.vue
// module id = 134
// module chunks = 0